export default __webpack_public_path__ + "static/media/three-dots.f58303b4.svg";